import { graphql, useStaticQuery } from 'gatsby';
import * as React from 'react'; // tslint:disable-line
import { VideosProvider as Provider } from '@shapeable/ui';
import { sortBy } from 'lodash';
import { shapeableProviderValue } from '@shapeable/gatsby-theme-shapeable-web/src/components/providers/provider-value';

const VIDEOS_QUERY = graphql`
query NodeAllVideosQuery {
  allShapeableCollectionRecord(filter: { collectionKey: { eq: "Videos" } }) {
    nodes {
      data
    }
  }
}
`;

export const VideosProvider: React.FC<any> = ({ children }) => {
  return (
    <Provider value={sortBy(shapeableProviderValue(useStaticQuery(VIDEOS_QUERY), 'items'), 'name')}>
      {children}
    </Provider>
  );
};
